import { processResult } from "immer/dist/internal";

type Dates = {
  startDate: string;
  endDate: string;
};

type URLs = {
  intake: {
    locationData: string;
    getModuleIfo: (projectId: string, bom: string) => string;
    moduleInfo: string;
    intakeSubmit: string;
    intakePannelSubmit: string;
    intakePannelBulkSubmit: string;
    scannItem: (serialNumber: string) => string;
    intakeInfo: (moduleId: string) => string;
    testType: (projectId: string, bom: string) => string;
    all: string;
    view: (id: string) => string;
    moduleInventory: (
      active: boolean,
      serial_number: string,
      project_number: string,
      customer: string,
      location: string,
      page: string,
      itemsPerPage: string,
    ) => string;
    moduleInventoryUnit: (serial_number: string) => string;
    update: string;
    transist_log: (
      start_datetime_after: string,
      start_datetime_before: string,
    ) => string;
    transist_log_download: (
      start_datetime_after: string,
      start_datetime_before: string,
    ) => string;
    delete: string;
  };

  // report Writer Agenda
  reportWriterAgenda: {
    submit: (page: string, itemsPerPage: string) => string;
    addNote: string;
    getnotes: (projectId: string) => string;
    reviewer: string;
    reportUpdate: (noteId: string) => string;
    notes: (noteId: string) => string;
    flag: string;
    writers: string;
    approvers: string;
    addReportTeam: string;
    reporttype: string;
    addTechWriterDate: (reportId: string) => string;
    reportWriter: string;
    moveApprover: string;
    writerHistory: string;
    writer_report_download: string;
    Check_List_Data: string;
    available_Check_List: (report_result_id: string) => string;
    pending_Check_List: (report_result_id: string) => string;
    Check_List_notes_get: (
      report_ID: string,
      checklist_id: string,
      checklist_report_id: string,
    ) => string;
    Check_List_notes_addNote: string;
    Add_Check_list: string;
    Checklist_comments: (noteId: string) => string;
    Check_List_notes_addComments: (
      report_ID: string,
      checklist_id: string,
      checklist_report_id: string,
      noteid: string,
    ) => string;
    project_download_get: (project_number: string) => string;
    project_download: (project_number: string) => string;
    report_project_Notes: (projectId: string) => string;
    DocumentUpload_Preview: (template_id: string) => string;
    getTemplateID: (reportType_id: string) => string;
    tiptapManualSave: string;
    tiptap_imageUpload: string;
    workerorder_imageUpload: string;
    ReportTypeUpload: (version: string) => string;
    UploadEditorTiptap: string;
    DocumentUploadTempData: string;
    UploadTemplateDelete: (template_id: string) => string;
    WriterAddComments: string;
    AcknowledgeComments: (report_result_id: string) => string;
    WriterGetAllviewComments: (
      report_result_id: string,
      is_writer: boolean,
    ) => string;

    reportGrid: (grid: string) => string;
    reportGridInfo: string;
    addCheckList: string;
    Check_List_notes_customCreate: string;
    Check_List_notes_acknowledged: string;
    DocumentCommentsDelete: (note_id: string) => string;
     CloudFileUpload: string;
  };

  //for Approver Agenda
  reportApproversAgenda: {
    submit: (page: string, itemsPerPage: string) => string;
    addNote: string;
    getnotes: (approverId: string) => string;
    addDateVerifiedByPM: (reportId: string) => string;
    addDateApprover: (reportId: string) => string;
    addDateDelivered: (reportId: string) => string;
    moveDelivered: string;
    moveWriter: string;
    deliveredHistory: string;
    approver_report_download: string;
    edit_reportTeam: (reportTeamId: string) => string;
  };

  procedureResults: {
    procedureDetails: (procedureResultId: string) => string;
    procedureStats: (facility: string) => string;
    verify: (location_id: string | number) => string;
    verify_result: (id: string | number) => string;
    count: (id: string | number) => string;
    view: (procedureResultId: string | number) => string;
    notes: (procedureResultId: string) => string;
    download: (procedureResultId: string) => string;
    addNote: (procedureResultId: string) => string;
    workLog: (days: string) => string;
    datesRange: (dates: Dates) => string;
    downloadLog: (startDate: string, endDate: string) => string;
    submit: (procedureResultId: string) => string;
    addStep: (procedureResultId: string) => string;
    updateFlag: (procedureResultId: string) => string;
    viewPreviousProcedureList: string;
    selectedProcedureFlashValues: string;
    ivcurveView: (
      procedureResultId: string | number,
      chartType: string,
    ) => string;

    // //pi data
    // viewPi: (procedureResultId: string | number) => string;
    // procedureStatsPi: (facility: string) => string;
  };
  measurementResults: {
    submit: (measurementResultId: string) => string;
    linkFiles: (measurementResultId: string) => string;
  };
  stepResults: {
    submit: (stepResult: string) => string;
    addMeasurement: (stepResultId: string) => string;
    notes: (stepResultId: string) => string;
    submitNote: string;
    testType: string;
    wetleakage: string;
  };
  allLabels: string;
  notes: {
    noteDetails: (noteId: string) => string;
    comments: (noteId: string) => string;
    emailNote: (noteId: string | number) => string;
    markRead: (noteId: string) => string;
    linkFiles: (noteId: string) => string;
    submitComment: string;
    bulkUpdate: (noteId: string) => string;
    addNote: string;
    flags: string;
    tasks: string;
    supportTickets: string;
    closedFlags: string;
    closedTasks: string;
    closedSupportTickets: string;
    noteCounts: string;
    closedFlagsDownload: string;
    flagDownload: string;
  };
  noteTypes: {
    byGroup: (filter: string) => string;
  };
  labels: {
    all: string;
    submit: string;
  };
  dispositions: {
    projects: string;
    all: string;
    units: string;
    notes: string;
    workOrderUnits: string;
    measurementResults: string;
    crates: string;
    workOrders: string;
    byName: (name: string) => string;

    projectsPi: string;
  };

  users: {
    submit: string;
    all: string;
    details: (userId: string) => string;
    edit: (userId: string) => string;
    active: string;
    lostPassword: (userId: string | null) => string;
    setPassword: (userId: string) => string;
    setGroups: (userId: string) => string;
    setAllowedTemplates: (userId: number) => string;
    myNotes: (closed: string | null) => string;
  };
  units: {
    all: string;
    unitDetails: (unitId: string) => string;
    linkFiles: (unitId: string) => string;
    magicLink: (unitId: string) => string;
    label: (unitId: string, token: string) => string;
    addNote: (unitId: string) => string;
    stressQueue: string;
    groupedHistory: (unitId: string) => string;
    notes: (unitId: string, type: number | null) => string;
    validAsset: (unitId: string) => string;
    bySerialNumber: (serialNumber: string | null) => string;
    byUpdatePauseResume: (serialNumber: string | null) => string;
    byAsset: (assetId: number) => string;
    endOfLifeQueue: (location_id: string | number) => string;
    appendTestSequence: (unitId: string) => string;
    getIntakeImage: (serialNumber: string | null) => string;
    downloadIntakeInfo: (serialNumber: string | null) => string;
    locationHistory: (serial_numbe: string) => string;
    locationHistoryDownload: (serial_numbe: string) => string;
    inventoryFilterDownload: (
      active: boolean,
      serial_number: string,
      project_number: string,
      customer: string,
      location: string,
      page: number,
      itemsPerPage: number,
    ) => string;
    inventoryDownload: (path: string) => string;
    addPriority: string;
    eoldisposition: string;
    unitVersion: (procedure_result_id: string) => string;
    stressFileList: (procedure_result_id: string) => string;
    stressRunfile: string;
  };

  update: {
    getlastUpdateProject: (projectId: string | null) => string;
    updateProjectDisposition: (projectId: string | null) => string;
    updateProject: (projectId: string | null) => string;
    lastUpdateProject: () => string;
  };
  projects: {
    submit: string;
    active_projects_report_download: string;
    projectDetails: (projectId: string | null) => string;
    projectUpdateCustomer: (project_number: string | null) => string;
    projectIntelligenceSummary: (projectId: string) => string;
    linkUnits: (projectId: string) => string;
    linkFiles: (projectId: string) => string;
    addNote: (projectId: string) => string;
    availableUnits: (projectId: string) => string;
    burndownGraph: (projectId: string) => string;
    allDownloads: (location_id: string | number) => string;
    selectedDownloads: (
      selectedIds: string | number | null,
      adjust_images: boolean | null,
      unitIds?: string | number,
      procedureIds?: string | number,
      tsdIds?: string | number,
    ) => string;
    download: (projectId: string | number) => string;
    projectType: string;
    activeProjects: (
      archived: string | boolean,
      location_id: string | number,
    ) => string;
    myProjects: (archived: string | boolean) => string;
    notes: (projectId: string) => string;
    notesAndType: (projectId: string, type: string | number | null) => string;
    workOrders: (projectId: string) => string;
    actions: (projectId: string) => string;
    addAction: (projectId: string) => string;
    projectFactoryWitness: string;
    max_tolerance: string;
    columnMaping: string;
  };
  plugins: {
    all: string;
    details: (pluginId: string | number) => string;
    testPlugin: (
      pluginId: string | number,
      serialize: boolean | null,
    ) => string;
    runPlugin: (pluginId: string | number, serialize: boolean | null) => string;
  };
  files: {
    azureFiles: string;
    azureFileDetails: (fileId: string) => string;
  };
  auth: {
    signin: string;
    whoami: string;
    forgotPassword: string;
  };
  testResults: {
    all: string;
  };
  wetLeakageViewer: {
    all: string;
  };
  manageResults: {
    permissions: string;
    retestProcedure: string;
    review: string;
    rerunSoak: string;
    recordCompletion: string;
  };
  crates: {
    all: string;
    details: (crateId: string) => string;
    submit: string;
    linkFiles: (crateId: string) => string;
    notes: (crateId: string, type: string | number | null) => string;
    markEmpty: string;
    addNote: (crateId: string) => string;
  };

  crateInsert: {
    submit: string;
    all: string;
    view: (id: string) => string;
    update: string;
  };
  workOrders: {
    submit: string;
    details: (workOrderId: string) => string;
    linkUnits: (workOrderId: string) => string;
    unlinkUnits: (workOrderId: string) => string;
    autoAssignUnits: (workOrderId: string) => string;
    assignUnits: (workOrderId: string | null) => string;
    intakeUnits: string;
    expectedUnitTypes: (workOrderId: string) => string;
    addTests: (workOrderId: string) => string;
    deleteTests: (workOrderId: string) => string;
    addAction: (workOrderId: string) => string;

    assignTsd: (workOrderId: string | null) => string;
    coverPage: (workOrderId: string | null) => string;
    addProcedure: string;
    getAllModules: (tsdId: string, workOrderId: string) => string;
  };
  expectedUnitTypes: {
    submit: string;
    details: (expectedUnitTypeId: string) => string;
    expectedUnitTypes: (project_id: string) => string;
  };
  locations: {
    all: string;
  };

  flashData: {
    all: string;
  };

  customers: {
    all: string;
    allPi: string;

    submit: string;
    details: (customerId: string) => string;
    detailsPi: (customerId: string) => string;
  };
  groups: {
    all: string;
    projectManagers: string;
    projects: string;
    users: string;
  };
  unitTypes: {
    all: string;
    submit: string;
    details: (unitTypeId: string) => string;
    linkFiles: (unitTypeId: string) => string;
  };
  testSequenceDefinitions: {
    all: string;
    mockTraveler: (testSequenceDefinitionId: string) => string;
    availableTsd: string;
  };
  moduleTechnologies: {
    all: string;
  };
  measurementTypes: {
    all: string;
  };
  reportTypes: {
    all: string;
  };
  //reportSequenceDefinitions
  reportSequenceDefinitions: {
    all: string;
  };

  createReportResult: {
    submit: string;
    update: string;
  };

  reportResult: {
    all: (work_order_id: string) => string;
    getUnitsProcedure: (serial_number: string) => string;
    getUnits: (work_order_id: string) => string;
  };

  //reportDisposition
  reportDispositions: {
    all: string;
  };

  //assignRsd
  assignRsd: {
    submit: string;
  };

  unitTypeFamilies: {
    all: string;
  };
  assetTypes: {
    all: string;
    byName: (filter: string) => string;
  };
  availableDefects: {
    all: string;
  };
  actionResults: {
    all: string;
    details: (id: string) => string;
    completed: (id: string) => string;
    linkFiles: (id: string) => string;
    mark_complete: (id: string) => string;
    revoke: (id: string) => string;
    reports: string;
    faild_report: (
      start_datetime_after: string,
      start_datetime_before: string,
      filterType: string,
      tsd_ids?: string,
    ) => string;
    faild_report_download: (
      start_datetime_after: string,
      start_datetime_before: string,
      filterType: string,
      procedure_ids: string,
    ) => string;

    retest_Required_Report: (
      start_datetime_after: string,
      start_datetime_before: string,
    ) => string;

    flash_report: (
      start_datetime_after: string,
      start_datetime_before: string,
    ) => string;
    flash_report_download: (
      start_datetime_after: string,
      start_datetime_before: string,
    ) => string;
    uvid_fe_flash_fileUpload: string;
    flash_correction_factor_download: string;
    uvid_fe_flash: (
      month: string,
      startDate: string,
      endDate: string,
      customer: string,
      projectNumber: string,
      serialNumber: string,
      workOrder: string,
      tsdName: string,
      offset: string,
      limit: string,
    ) => string;
    uvid_fe_flash_download: (
      month: string,
      startDate: string,
      endDate: string,
      customer: string,
      project: string,
      serialNumber: string,
      workOrder: string,
      tsdName: string,
    ) => string;
    flash_filter_download: (id: string[]) => string;

    update: string;
  };
  actionDefinitions: {
    all: string;
  };
  templates: {
    all: string;
    add: string;
    details: (id: string) => string;
  };
  fileFormats: {
    all: string;
  };
  userRegistrationStatus: {
    all: string;
  };
  deliverables: {
    deliverableInsert: string;
    deliverablescoverdata: (workorder_id: string | null) => string;
    deliverableFlashData: string;
    deliverableELData: string;

    resultViewDataDownload: (
      work_order_id: string,
      procedure_definition_id: string,
    ) => string;
  };

  assets: {
    submit: string;
    revoke: string;
    asset_disposition: string;
    view_asset: (id: string | null) => string;
    calibration_data: (assetId: string | null) => string;
    checkLinkedAssets: (linkAssetId: string | null) => string;
    stress_run: string;
    listAssets: (is_main_asset: boolean | null) => string;
    linkNewAsset: string;
    linkPowerSupplySubAssetGet: string;
    linkedSubAssetList: string;
    removeLinkAsset: (assetId: string | null) => string;
    editSubAssetList: (id: number | null) => string;
    lastActionAsset: (id: string) => string;
    linkedSubAssetListbyID: (id: any) => string;
    AssetCalibrationHistoryGet: (id: any) => string;
    VerifyCalibrationDate: string;
    DownloadAsset: string;
    AssetCalibrationListView: (date: string, all: boolean) => string;
    AssetCalibrationMail: (
      date: string,
      all: boolean,
      emails: string[],
    ) => string;
    ElAsset: string;
  };

  ProcedureComments: {
    getProcedureComments: (id: string) => string;
    submit: string;
    recordAcknowledgement: string;
  };

  EdgePinchUpload: {
    submit: string;
    retestgetEdgepinch: (serialNumber: string | null) => string;
    retestSubmit: string;
    Workorderlist: (projectId: string | null) => string;
    EdgePinchProjectGet: string;
  };

  //elo
  eolDispositions: {
    update: string;
  };

  reportFileTemplate: {
    submit: string;
    viewTemplate: (id: string | null) => string;
  };

  preWriterQueue: {
    submit: (page: string, itemsPerPage: string) => string;
    status_view: (report_result_id: string) => string;
  };
  reportBuilder: {
    submit: string;
  };

  feedback: {
    getAllFeedback: string;
  };
  smlFileUpload: {
    uploadExcel: string;
  };
  docgen: {
    reportTemplate: (report_result_id: number, template: string) => string;

    workOrderImage: (workorder_id: number) => string;

    GetreportTemplateData: (
      report_result_id: number,
      template: string,
    ) => string;
    GetreportIntakeImages: (report_result_id: string) => string;
    moveReport: string;
    GetreportProjectNotes: (projectId: number) => string;
  };
};

export const urls: URLs = {
  intake: {
    locationData: "moduleintake/details/",
    getModuleIfo: (projectId: string, bom: string) =>
      `getmodeltype/${bom}/?project_id=${projectId}`,
    moduleInfo: `getmoduledetails`,
    intakeSubmit: "moduleintakedetails/",
    intakePannelSubmit: "scanned_pannels/",
    intakePannelBulkSubmit: "bulk_insert_for_scanned_panel/",
    scannItem: (serialNumber: string) => `scannedunitdetails/${serialNumber}`,
    intakeInfo: (moduleId: string) => `moduleintakedetails/${moduleId}`,
    testType: (projectId: string, bom: string) =>
      `test-type/find_workorder_and_assign_units/?project_id=${projectId}&name=${bom}`,
    all: "moduleintakedetails/?limit=-1",
    view: (id: string) => `get_all_module_details/${id}/`,
    moduleInventory: (
      active: boolean,
      serial_number: string,
      project_number: string,
      customer: string,
      location: string,
      page: string,
      itemsPerPage: string,
    ) =>
      `/module_inventory/?active=${active}&serial_number=${serial_number}&project_number=${project_number}&customer=${customer}&location=${location}&limit=${itemsPerPage}&offset=${page}`,
    moduleInventoryUnit: (serial_number: string) =>
      `/module_inventory/${serial_number}/`,
    update: "/module_update/update_image/",
    transist_log: (start_datetime_after, start_datetime_before) =>
      `location_log/between-dates/?start_date=${start_datetime_after}&end_date=${start_datetime_before}`,
    transist_log_download: (start_datetime_after, start_datetime_before) =>
      `location_log/between-dates/download/?start_date=${start_datetime_after}&end_date=${start_datetime_before}`,
    delete: `/deletemoduleintake/custom_delete/`,
  },

  procedureResults: {
    procedureDetails: (procedureResultId) =>
      `procedure_results/${procedureResultId}/`,
    procedureStats: (facility) =>
      `procedure_results/procedure_stats/?facility=${facility}`,
    verify: (location_id) =>
      `procedure_results/verify/?location=${location_id}`,
    verify_result: (id) => `procedure_results_verify/${id}`,
    count: (id) => `count/${id}`,
    view: (procedureResultId) => `procedure_results/${procedureResultId}/view/`,
    notes: (procedureResultId) =>
      `procedure_results/${procedureResultId}/notes/`,
    download: (procedureResultId) =>
      `procedure_results/${procedureResultId}/download/`,
    addNote: (procedureResultId) =>
      `procedure_results/${procedureResultId}/add_note/`,
    workLog: (days) => `/procedure_results/worklog/?days=${days}`,
    datesRange: (dates) =>
      `procedure_results/worklog/?start_datetime=${dates.startDate}&end_datetime=${dates.endDate}`,
    downloadLog: (startDate, endDate) =>
      `procedure_results/worklog/?start_datetime=${startDate}&end_datetime=${endDate}&file=excel`,
    submit: (procedureResultId) =>
      `procedure_results/${procedureResultId}/submit/`,
    addStep: (procedureResultId) =>
      `procedure_results/${procedureResultId}/add_step/`,
    updateFlag: (procedureResultId) =>
      `/procedureflagupdate/${procedureResultId}/`,

    viewPreviousProcedureList: `procedure_results/valid_procedure/`,
    selectedProcedureFlashValues: `/procedure_results/flash_values/`,
    ivcurveView: (procedureResultId, chartType) =>
      `procedure_results/${procedureResultId}/view/?chart_type=${chartType}`,
  },
  measurementResults: {
    submit: (measurementResultId) =>
      `measurement_results/${measurementResultId}/submit/`,
    linkFiles: (measurementResultId) =>
      `measurement_results/${measurementResultId}/link_files/`,
  },
  stepResults: {
    submit: (stepResultId) => `step_results/${stepResultId}/submit/`,
    addMeasurement: (stepResultId) =>
      `step_results/${stepResultId}/add_measurement/`,
    submitNote: `step_result_notes/`,
    notes: (stepResultId) => `step_result_notes/${stepResultId}`,
    testType: `step_result_notes/test_type/`,
    wetleakage: `step_result_notes/latest_wetleakage/`,
  },
  allLabels: "labels/?limit=-1",
  notes: {
    noteDetails: (noteId) => `notes/${noteId}/`,
    comments: (noteId) => `notes/${noteId}/get_children/`,
    emailNote: (noteId) => `notes/${noteId}/email_note/`,
    markRead: (noteId) => `notes/${noteId}/mark_read/`,
    linkFiles: (noteId) => `notes/${noteId}/link_files/`,
    submitComment: `notes/`,
    bulkUpdate: (noteId) => `notes/${noteId}/bulk_update/`,
    addNote: `notes/add_note/`,
    flags: "notes/flags/?limit=-1",
    tasks: "notes/tasks/?limit=-1",
    supportTickets: "notes/support_tickets/?limit=-1",
    closedFlags: "engineeringagenda/closed_flags/",
    closedTasks: "notes/closed_tasks/?limit=-1",
    closedSupportTickets: "notes/closed_support_tickets/?limit=-1",
    noteCounts: "notes/dashboard_counts/",
    closedFlagsDownload: "engineeringagenda/closed_flags/download/",
    flagDownload: "notes/flags/download",
  },
  noteTypes: {
    byGroup: (filter) => `/note_types/?groups__name=${filter}`,
  },
  labels: {
    all: "labels/?limit=-1",
    submit: "labels/",
  },
  dispositions: {
    projects: "projectdisposition/",
    all: "dispositions/?limit=-1",
    units: "units/dispositions/",
    notes: "notes/dispositions/",
    workOrderUnits: "work_orders/unit_dispositions/",
    measurementResults: "measurement_results/dispositions/",
    crates: "crates/dispositions/?limit=-1",
    workOrders: "work_orders/dispositions/?limit=-1 ",
    byName: (name) => `dispositions/?name=${name}`,

    projectsPi: "disposition_pichina/",
  },
  users: {
    submit: "users/",
    all: `users/?limit=-1`,
    details: (userId) => `users/${userId}/`,
    edit: (userId) => `users/${userId}/edit/`,
    active: "users/?is_active=true&limit=-1",
    lostPassword: (userId) => `users/${userId}/lost_password/`,
    setPassword: (userId) => `users/${userId}/set_password/`,
    setGroups: (userId) => `users/${userId}/set_groups/`,
    setAllowedTemplates: (userId) => `users/${userId}/set_allowed_templates/`,
    myNotes: (closed) => `users/my_notes/?closed=${closed}`,
  },
  units: {
    all: "units/?limit=-1",
    unitDetails: (unitId) => `units/${unitId}/`,
    linkFiles: (unitId) => `units/${unitId}/link_files/`,
    magicLink: (unitId) => `units/${unitId}/get_magic_link/`,
    label: (unitId, token) => `units/${unitId}/get_label/?token=${token}`,
    addNote: (unitId) => `units/${unitId}/add_note/`,
    stressQueue: "units/stress_queue/",
    groupedHistory: (unitId) => `units/${unitId}/grouped_history/`,
    notes: (unitId, type) => `units/${unitId}/notes/?type=${type}`,
    validAsset: (unitId) => `units/${unitId}/valid_asset/`,
    bySerialNumber: (serialNumber) => `units/?serial_number=${serialNumber}`,
    byUpdatePauseResume: (serialNumber) =>
      `units/update_pause_resume_status/${serialNumber}/`,
    byAsset: (assetId) => `assets/${assetId}/units/`,
    endOfLifeQueue: (location_id) =>
      "units/end_of_life/?location=" + location_id,
    appendTestSequence: (unitId) => `units/${unitId}/append_test_sequence/`,
    getIntakeImage: (serialNumber) => `/intake_images_info/${serialNumber}/`,
    downloadIntakeInfo: (serialNumber) =>
      `/intake_images_info/${serialNumber}/download-excel/`,
    locationHistory: (serialNumber) =>
      `/location_log/${serialNumber}/unit_history`,
    locationHistoryDownload: (serialNumber) =>
      `/location_log/${serialNumber}/unit_history//download_csv`,
    inventoryFilterDownload: (
      active: boolean,
      serial_number: string,
      project_number: string,
      customer: string,
      location: string,
      page: number,
      itemsPerPage: number,
    ) =>
      `/module_inventory/download_csv/?active=${active}&serial_number=${serial_number}&project_number=${project_number}&customer=${customer}&location=${location}&limit=${itemsPerPage}&offset=${page}`,
    inventoryDownload: (path) => `module_inventory/${path}`,
    addPriority: `/units/set_priority/`,
    eoldisposition: `/work_orders/eol_dispositions/`,
    unitVersion: (procedure_result_id) =>
      `/units/unit_version/?procedure_result_ids=${procedure_result_id}`,
    stressFileList: (procedure_result_id) =>
      `/units/stress_upload/?procedure_result_ids=${procedure_result_id}`,
    stressRunfile: "/units/run_and_log_files/",
    // //pidata

    // bySerialNumberPi:(serialNumber) => `unit_pichina/?serial_number=${serialNumber}`,
    // groupedHistoryPi: (unitId) => `unit_pichina/${unitId}/grouped_history/`,
  },

  update: {
    updateProject: (projectId) => `updateproject/${projectId}/`,
    lastUpdateProject: () => `projectmodifieddetails/`,
    updateProjectDisposition: (projectId) =>
      `dispositionbulkupdate/${projectId}/`,
    getlastUpdateProject: (projectId) =>
      `projectmodifieddetails/${projectId}/?limit=-1`,
  },
  projects: {
    submit: "projects/",
    active_projects_report_download:
      "activeprojectreport/active_projects/?show_archived=false/",
    projectDetails: (projectId) => `projects/${projectId}/`,
    projectUpdateCustomer: (project_number) =>
      `updateprojectforcustomer/${project_number}/`,
    projectIntelligenceSummary: (projectId) =>
      `projects/${projectId}/pi_summary_table/`,
    linkUnits: (projectId) => `projects/${projectId}/link_units/`,
    linkFiles: (projectId) => `projects/${projectId}/link_files/`,
    addNote: (projectId) => `projects/${projectId}/add_note/`,
    availableUnits: (projectId) => `projects/${projectId}/available_units/`,
    burndownGraph: (projectId) => `projects/${projectId}/burndown_graph/`,
    allDownloads: (location_id) =>
      `projects/download/?limit=-1&location=${location_id}`,
    selectedDownloads: (
      selectedIds,
      adjust_images,
      unitIds,
      procedureIds,
      tsdIds,
    ) => {
      let finalString = `projects/download/?workorder_ids=${selectedIds}&adjust_images=${adjust_images}`;

      if (unitIds) finalString += `&unit_ids=${unitIds}`;
      if (procedureIds) finalString += `&procedure_ids=${procedureIds}`;
      if (tsdIds) finalString += `&test_sequence_definition_ids=${tsdIds}`;

      return finalString;
    },
    download: (projectId) => `projects/${projectId}/download_project/`,
    projectType: "projecttypedetails/",
    activeProjects: (archived, location_id) =>
      `projects/active_projects/?show_archived=${archived}&location=${location_id}`,
    myProjects: (archived) => `projects/my_projects/?show_archived=${archived}`,
    notes: (projectId) => `projects/${projectId}/notes/`,
    notesAndType: (projectId, type) =>
      `projects/${projectId}/notes/?type=${type}`,
    workOrders: (projectId) => `projects/${projectId}/work_orders/`,
    actions: (projectId) => `projects/${projectId}/actions/`,
    addAction: (projectId) => `projects/${projectId}/new_action/`,
    projectFactoryWitness: `/project_factory_witness/`,
    max_tolerance: `max_tolerance/`,
    columnMaping: "/projects/import_manufacturer_characterization/",
  },
  plugins: {
    all: "plugins/?limit=-1",
    details: (pluginId) => `plugins/${pluginId}/`,
    testPlugin: (pluginId, serialize) =>
      `plugins/${pluginId}/test_plugin/?serialize=${serialize}`,
    runPlugin: (pluginId, serialize) =>
      `plugins/${pluginId}/run_plugin/?serialize=${serialize}`,
  },
  files: {
    azureFiles: `azure_files/`,
    azureFileDetails: (fileId) => `azure_files/${fileId}/`,
  },
  auth: {
    signin: "signin/",
    whoami: "whoami/",
    forgotPassword: "forgot_password/",
  },
  testResults: {
    all: "test_results/?limit=-1",
  },
  wetLeakageViewer: {
    all: "wet_leakage_viewer/",
  },
  manageResults: {
    permissions: "manage_results/",
    retestProcedure: `manage_results/retest_procedure/`,
    review: `manage_results/review/`,
    rerunSoak: `manage_results/rerun_soak/`,
    recordCompletion: "manage_results/record_completion/",
  },
  crates: {
    all: `crates/?limit=-1`,
    details: (crateId) => `crates/${crateId}/`,
    submit: "crates/",
    linkFiles: (crateId) => `crates/${crateId}/link_files/`,
    notes: (crateId, type) => `crates/${crateId}/notes/?type=${type}`,
    markEmpty: `crates/mark_empty/`,
    addNote: (crateId) => `crates/${crateId}/add_note/`,
  },

  crateInsert: {
    submit: "new_crates/",
    all: "crateintakegrid/?limit=-1",
    view: (id: string) => `get_all_crate_details/${id}/`,
    update: "/crate_update/update_image/",
  },
  workOrders: {
    submit: "work_orders/?limit=-1",
    details: (workOrderId) => `work_orders/${workOrderId}/`,
    linkUnits: (workOrderId) => `work_orders/${workOrderId}/link_units/`,
    unlinkUnits: (workOrderId) => `work_orders/${workOrderId}/unlink_units/`,
    autoAssignUnits: (workOrderId) =>
      `work_orders/${workOrderId}/autoassign_units/`,
    assignUnits: (workOrderId) => `work_orders/${workOrderId}/assign_units/`,
    intakeUnits: "work_orders/intake_units/",
    expectedUnitTypes: (workOrderId) =>
      `work_orders/${workOrderId}/expected_unit_types/`,
    addTests: (workOrderId) => `work_orders/${workOrderId}/add_tests/`,
    deleteTests: (workOrderId) => `work_orders/${workOrderId}/delete_tests/`,
    addAction: (workOrderId) => `work_orders/${workOrderId}/new_action/`,
    assignTsd: (workOrderId) =>
      `getproceduredefinitionlist/get_procedure_definitions/?workorder_id=${workOrderId}`,
    coverPage: (workOrderId) => `get-deliverables-cover/${workOrderId}/`,
    addProcedure: `work_orders/in_out_stabilization/`,
    getAllModules: (tsdId, workOrderId) =>
      `/work_orders/${workOrderId}/workorder_units/?test_sequence=${tsdId}`,
  },
  expectedUnitTypes: {
    submit: "expected_unit_types/",
    details: (expectedUnitTypeId) =>
      `expected_unit_types/${expectedUnitTypeId}/`,
    expectedUnitTypes: (project_id) =>
      `expected_unit_types/by-project/?project_id=${project_id}`,
  },
  locations: {
    all: "locations/",
  },

  flashData: {
    all: "flashtestdetails/",
  },

  customers: {
    all: "customers/?limit=-1",
    allPi: "customer_pichina/",
    submit: "customers/",
    details: (customerId) => `customers/${customerId}/`,

    detailsPi: (customerId) => `customer_pichina/${customerId}/`,
  },
  groups: {
    all: "groups/?limit=-1",
    projectManagers: "groups/?name=Project Managers&limit=-1",
    projects: "groups/?name=Projects&limit=-1",
    users: `groups/?group_type__name=Users&limit=-1`,
  },
  unitTypes: {
    all: "unit_types/?limit=-1",
    submit: "unit_types/",
    details: (unitTypeId) => `unit_types/${unitTypeId}/`,
    linkFiles: (unitTypeId) => `unit_types/${unitTypeId}/link_files/`,
  },

  testSequenceDefinitions: {
    all: "test_sequence_definitions/?limit=-1&disposition=16",
    mockTraveler: (testSequenceDefinitionId) =>
      `test_sequence_definitions/${testSequenceDefinitionId}/mock_traveler/`,
    availableTsd: "reportexecutionorder/available_tsd/",
  },
  moduleTechnologies: {
    all: "module_technologies/?limit=-1",
  },
  measurementTypes: {
    all: "measurement_types/?limit=-1",
  },
  reportTypes: {
    all: "report_types/?limit=-1",
  },
  //reportSequenceDefinitions
  reportSequenceDefinitions: {
    all: "reportsequencedefinition/?limit=-1",
  },
  createReportResult: {
    submit: "reportresult/create_report_result/",
    update: "reportresult/update_report_result/",
  },
  //reportDispositions
  reportDispositions: {
    all: "reportresult/report_dispositions/",
  },
  reportResult: {
    all: (work_order_id) => `reportresult/?work_order_id=${work_order_id}`,
    getUnitsProcedure: (serial_number) =>
      `reportresult/get_unit_procedureresult_name/?serial_number=${serial_number}`,
    getUnits: (work_order_id) =>
      `reportresult/get_unit_tsds/?work_order_id=${work_order_id}`,
  },

  //assignRSD
  assignRsd: {
    submit: `reportresult/update_report_result/`,
  },
  unitTypeFamilies: {
    all: "unit_type_families/?limit=-1",
  },
  assetTypes: {
    all: "asset_types/?limit=-1",
    byName: (filter) => `asset_types/?name=${filter}`,
  },
  availableDefects: {
    all: `available_defects/?limit=-1`,
  },
  actionResults: {
    all: `action_results/?limit=-1`,
    details: (actionResultId) => `action_results/${actionResultId}/`,
    completed: (actionResultId) =>
      `action_results/${actionResultId}/check_complete/`,
    linkFiles: (actionResultId) =>
      `action_results/${actionResultId}/link_files/`,
    mark_complete: (actionResultId) =>
      `action_results/${actionResultId}/mark_complete/`,
    revoke: (actionResultId) => `action_results/${actionResultId}/revoke/`,
    reports: "action_results/reports/",
    faild_report: (start_date, end_date, filterType, tsd_ids) =>
      `failedprojectreport/?start_date=${start_date}&end_date=${end_date}&is_mss=${filterType}&tsd_ids=${tsd_ids}`,
    faild_report_download: (start_date, end_date, filterType, procedure_ids) =>
      `failedprojectreport/download_csv/?start_date=${start_date}&end_date=${end_date}&is_mss=${filterType}&procedure_ids=${procedure_ids}`,

    retest_Required_Report: (start_date, end_date) =>
      `retest_required_report/?start_date=${start_date}&end_date=${end_date}`,

    flash_report: (start_datetime_after, start_datetime_before) =>
      `flash_test/?start_datetime_after=${start_datetime_after}&start_datetime_before=${start_datetime_before}`,
    flash_report_download: (start_datetime_after, start_datetime_before) =>
      `/flash_test/download/?start_datetime_after=${start_datetime_after}&start_datetime_before=${start_datetime_before}`,
    update: "flash_test/update-measurement/",
    flash_correction_factor_download:
      "measurement_correctionfactor/corrected_procedures/download-excel",

    uvid_fe_flash_fileUpload:
      "uvid-flash-report/correction_factor_file_upload/",
    uvid_fe_flash: (
      month,
      startDate,
      endDate,
      customer,
      projectNumber,
      workOrder,
      serialNumber,
      tsdName,
      offset,
      limit,
    ) =>
      `uvid-flash-report/?date=${month}&start_date=${startDate}&end_date=${endDate}&customer=${customer}&project=${projectNumber}&serial_number=${serialNumber}&workorder=${workOrder}&test_sequence=${tsdName}&limit=${limit}&offset=${offset}`,
    uvid_fe_flash_download: (
      month,
      startDate,
      endDate,
      customer,
      project,
      serialNumber,
      workOrder,
      tsdName,
    ) =>
      `uvid-flash-report/download_excel/?date=${month}&start_date=${startDate}&end_date=${endDate}&customer=${customer}&project=${project}&serial_number=${serialNumber}&workorder=${workOrder}&test_sequence=${tsdName}`,
    flash_filter_download: (id) =>
      `uvid-flash-report/download_filtered_excel/?id=${id}`,
  },
  actionDefinitions: {
    all: `action_definitions/`,
  },
  templates: {
    all: "templates/?limit=-1",
    add: "templates/",
    details: (id: string) => `templates/${id}/`,
  },
  fileFormats: {
    all: "file_formats/?limit=-1",
  },
  userRegistrationStatus: {
    all: "user_registration_statuses/?limit=-1",
  },

  assets: {
    submit: "/assetcalibration/?limit=-1",
    revoke: "/revokedassetdetails/",
    asset_disposition: "/assetcalibration/asset_dispositions/",
    view_asset: (id) => `assetcalibration/${id}/`,
    calibration_data: (assetId) =>
      `assetcalibration/asset_info/?asset_id=${assetId}`,
    checkLinkedAssets: (linkAssetId) => `subasset/${linkAssetId}`,
    stress_run: "/asset_subasset/stress_run/",
    listAssets: (is_main_asset) =>
      `/assetcalibration/link_asset_subasset/?is_main_asset=${is_main_asset}`,
    linkNewAsset: "/assetcalibration/link_asset_subasset/",
    linkPowerSupplySubAssetGet: "/assetcalibration/psr_subassets/",
    linkedSubAssetList: "/assethistory/asset_list/",
    removeLinkAsset: (assetId) =>
      `/assetcalibration/link_asset_subasset/?asset_calibration_id=${assetId}`,
    editSubAssetList: (id) => `/assetcalibration/edit_asset_get/?id=${id}`,
    lastActionAsset: (id) => `/asset_last_action/${id}/`,
    linkedSubAssetListbyID: (id) =>
      `/assethistory/asset_list_calibration/?asset_calibration_id=${id}`,
    AssetCalibrationHistoryGet: (id) =>
      `/assetcalibration/calibration_history/?asset_id=${id}`,
    VerifyCalibrationDate: `/assetcalibration/update_calibration_status/`,
    DownloadAsset: `/assetcalibration/download_calibration/`,

    AssetCalibrationListView: (date, all) =>
      `/assetcalibrationemail/asset_list/?date=${date}&all=${all}`,
    AssetCalibrationMail: (date, all, emails) =>
      `/assetcalibrationemail/send_email/?date=${date}&all=${all}&emails=${emails}`,
    ElAsset: `assets/?disposition_id=16&limit=-1`,
  },

  //ForDelivarables
  deliverables: {
    deliverableInsert: "deliverablescoverdata/",
    deliverablescoverdata: (workorder_id) =>
      `deliverablescoverdata/${workorder_id}/`,
    deliverableFlashData: `flashdatadeliverables/deliverables_data/`,
    deliverableELData: "flashdatadeliverables/el_images/",
    resultViewDataDownload: (
      work_order_id: string,
      procedure_definition_id: string,
    ) =>
      `download_deliverable_data/?work_order_id=${work_order_id}&procedure_definition_id=${procedure_definition_id}`,
  },

  //eol
  eolDispositions: {
    update: "module_inventory/bulk_eol_disposition_update/",
  },

  //For reportWriterAgenda
  reportWriterAgenda: {
    submit: (page: string, itemsPerPage: string) =>
      `reportwriteragenda/?&limit=${itemsPerPage}&offset=${page}`,
    addNote: `reportnotes/`,
    getnotes: (reportId) => `reportnotes/by-report/?report_id=${reportId}`,
    reviewer: `reportreviewer/`,
    reportUpdate: (noteId) => `/reportnotes/${noteId}/add_note/`,
    notes: (noteId) => `reportnotes/${noteId}/get_children/`,
    flag: `reportnotes/add_flag/`,
    writers: `reportteam/group-users/`,
    approvers: `reportteam/approvers/`,
    addReportTeam: `reportteam/`,
    reporttype: `reporttypedefinition/?disposition_id=16`,
    addTechWriterDate: (reportId) =>
      `reportwriteragenda/${reportId}/insert_date_time/`,
    reportWriter: `reportwriteragenda/writer_reviewer_update/`,
    moveApprover: `reportwriteragenda/send_to_aprover_grid/`,
    writerHistory: `writer_history/`,
    writer_report_download: `/reportwriteragenda/download_report_writer_agenda/`,
    Check_List_Data: `checklistreport/`,
    available_Check_List: (report_result_id) =>
      `reportchecklistdata/add_reportchecklistdata/?report_result_id=${report_result_id}`,
    pending_Check_List: (report_result_id) =>
      `reportchecklistdata/pending_reportchecklistdata/?report_result_id=${report_result_id}`,
    Check_List_notes_get: (report_ID, checklist_id, checklist_report_id) =>
      `/reportchecklistnote/by-report/?report_result_id=${report_ID}&checklist_id=${checklist_id}&checklist_report_id=${checklist_report_id}`,
    Check_List_notes_addNote: `reportchecklistnote/`,
    Add_Check_list: `reportchecklistdata/add_reportchecklistdata/`,
    Checklist_comments: (noteId) =>
      `/reportchecklistnote/${noteId}/get_comments/`,
    Check_List_notes_addComments: (
      report_ID,
      checklist_id,
      checklist_report_id,
      noteid,
    ) =>
      `reportchecklistnote/${noteid}/add_comments/?checklist=${checklist_id}&checklist_report=${checklist_report_id}&report=${report_ID}`,
    project_download_get: (project_number) =>
      `/projectdownload/${project_number}/`,
    project_download: (project_number) => {
      return `/projectdownload/${project_number}/download/`;
    },
    report_project_Notes: (projectId) => `projects/${projectId}/notes/`,
    DocumentUpload_Preview: (template_id) =>
      `/writer_history/get_template/?template_id=${template_id}`,
    getTemplateID: (reportType_id) =>
      `/writer_history/edit_template/?reporttype_id=${reportType_id}`,
    tiptapManualSave: `/docgen/report-template/save_document/`,
    tiptap_imageUpload: `docgen/report-template/upload_new_image/`,
    workerorder_imageUpload: "/projects/read_excel/",
    ReportTypeUpload: (version) =>
      `/reporttypedefinition/template_upload/?disposition_id=16&version=${version}`,
    UploadEditorTiptap: `/writer_history/update_doc/`,
    DocumentUploadTempData: `/document_template/`,
    UploadTemplateDelete: (template_id) =>
      `document_template/template_delete/?document_template=${template_id}`,
    WriterAddComments: `/reportwriteragenda/create_report_comments/`,
    AcknowledgeComments: (report_result_id) =>
      `/reportwriteragenda/acknowledge_comments/?report_result_id=${report_result_id}`,
    WriterGetAllviewComments: (report_result_id: string, is_writer: boolean) =>
      `/reportwriteragenda/get_comments/?report_result_id=${report_result_id}&is_writer=${is_writer}`,

    reportGrid: (grid: string) =>
      `/reportwriteragenda/report_grid/?grid=${grid}`,

    reportGridInfo: `/reportwriteragenda/report_grid_info/`,
    addCheckList: `/reportchecklistdata/add_reportchecklistdata/`,
    Check_List_notes_customCreate: `/reportchecklistnote/custom_create/`,
    Check_List_notes_acknowledged: `/reportchecklistnote/acknowledged/`,
    DocumentCommentsDelete: (note_id) =>
      `reportwriteragenda/delete_report_comments/?note_id=${note_id}`,
    CloudFileUpload: `/module_intake_images/update_captions/`,
  },

  //For reportAppproversAgenda
  reportApproversAgenda: {
    submit: (page: string, itemsPerPage: string) =>
      `/reportapproveragenda/?&limit=${itemsPerPage}&offset=${page}`,
    addNote: `reportapprovernotes/`,
    getnotes: (approverId) =>
      `reportapprovernotes/by-report/?report_id=${approverId}`,
    addDateVerifiedByPM: (reportId) =>
      `reportapproveragenda/${reportId}/date_verified/`,
    addDateApprover: (reportId) =>
      `reportapproveragenda/${reportId}/date_approved/`,
    addDateDelivered: (reportId) =>
      `reportapproveragenda/${reportId}/date_delivered/`,
    moveDelivered: `reportapproveragenda/send_to_delivered_grid/`,
    moveWriter: `delivered_report/reject/`,
    deliveredHistory: `delivered_report/`,
    approver_report_download: `reportapproveragenda/download_report_approver_agenda/`,
    edit_reportTeam: (reportTeamId) => `reportteam/${reportTeamId}/`,
  },

  reportFileTemplate: {
    submit: `reportfiletemplate/`,
    viewTemplate: (id) =>
      `reportfiletemplate/filter_by_report/?report_id=${id}`,
  },

  //PreWritterQueue
  preWriterQueue: {
    submit: (page: string, itemsPerPage: string) =>
      `/reportresult/pre_report_writer/?&limit=${itemsPerPage}&offset=${page}`,
    status_view: (report_result_id) =>
      `/reportresult/report_progress/?report_result_id=${report_result_id}`,
  },
  //reportBuilder
  reportBuilder: {
    submit: `/notes/fetch_notes/`,
  },
  feedback: {
    getAllFeedback: `/feedbackios/`,
  },

  ProcedureComments: {
    getProcedureComments: (id) =>
      `procedureresult_comments/?procedure_result=${id}`,
    submit: `/procedureresult_comments/`,
    recordAcknowledgement: `/procedureresult_comments/record_aknowledgement/`,
  },

  EdgePinchUpload: {
    submit: `edge_pinch_upload/save_edge_pinch_results/`,
    retestgetEdgepinch: (serialnumber) =>
      `/edge_pinch_upload/edge_pinch_retest/?serial_number=${serialnumber}`,
    retestSubmit: `/edge_pinch_upload/save_retest/`,
    Workorderlist: (projectId) =>
      `/projects/get_edgepinch_workorders/?project_id=${projectId}`,
    EdgePinchProjectGet: `/projects/get_edgepinch_projects/`,
  },
  smlFileUpload: {
    uploadExcel: `/sml_fileupload/upload_excel/`,
  },
  docgen: {
    reportTemplate: (report_result_id: number, template: string) =>
      `/docgen/${template}/?report_result_id=${report_result_id}`,

    workOrderImage: (workorder_id: number) =>
      `/docgen/report-template/bind_images/?workorder_id=${workorder_id}`,
    GetreportTemplateData: (report_result_id: number, template: string) =>
      `/docgen/${template}/get_document/?report_result_id=${report_result_id}`,
    GetreportIntakeImages: (report_result_id: string) =>
      `module_intake_images/get_moduleintakeimagebyworkorderid/?report_result_id=${report_result_id}`,
    moveReport: `/reportwriteragenda/move_report/`,
    GetreportProjectNotes: (projectId: number) =>
      `/projects/${projectId}/notes/?type=1`,
  },
};
